import { participantFunctionsDSP } from '@openx/components-deal/lib/utils/participantFunctions';

export const useParticipantFunctions = () => {
  return participantFunctionsDSP;
};
